import { Component, OnInit } from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {SelectionModel} from '@angular/cdk/collections';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_leaderGo } from 'app/idiomas/i18n/leaderGo/leaderGo.lang';
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import * as backInter from 'app/auth/auth-data.model';
import { IdiomasService } from 'app/main/wizard-leader/services/idiomas.service';
import { LeaderSelectService } from 'app/main/wizard-leader/services/leaderSele.service';
import { WizardLeaderService } from 'app/main/wizard-leader/services/wizard.service';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import { MatDialog } from '@angular/material/dialog';
import { ModalInfoComponent } from "./modal-info/modal-info.component";
@Component({
  selector: 'app-table-leader-go',
  templateUrl: './table-leader-go.component.html',
  styleUrls: ['./table-leader-go.component.scss']
})
export class TableLeaderGoComponent implements OnInit {
  pasoCompleto: boolean=false;
  cargando:boolean=true;
  filtrandoLide:boolean=false;
  lideresSeleccionados:boolean=false;
  productoCertificar: any;
    displayedColumns: string[] = ['name','correo','area', 'cupones'];
    dataSource: MatTableDataSource<any>;
    dataSourceLeadersSele: MatTableDataSource<any>;
    selection = new SelectionModel<any>(true, []);
    lideresCerAso:any[]=[];
    lideresCerAsoSave:any[]=[];
    filtroAbierto=false;
    busquedaLiaders="";
  descargado:boolean=false;
  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private idiomasService: IdiomasService,
    private leaderService: LeaderSelectService,
    private wizardService: WizardLeaderService,
    private dialog: MatDialog,
  ) {
    lang_certificar.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    lang_leaderGo.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    lang_perfiles.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    this.obtieneCertificarActual();
  }
  obtieneCertificarActual(){
    this.leaderService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodCert[] = data.productosCertificar;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            let fecha = producto.fechaCertificar;
            let idProducto = producto.idCertificar;
            if(fecha == parseInt(localStorage.getItem('fechaProducto')) && idProducto == localStorage.getItem('productoID')){
              this.productoCertificar = producto;
              console.log("*********************", this.productoCertificar);

            throw BreakException;
            }
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };
      //obtiene el status del paso idiomas del certificar vigente

        this.leaderService.getStatusIdioma(this.productoCertificar.idCertificar).subscribe( (data: backInter.getStatusIndiv) => {
          console.log('entro get paso idiomas producto normal',data);
          if(data.estatus === 3)
          this.pasoCompleto = true;
        });
        this.getLideresCerAsociado(this.productoCertificar.asociadoId,this.productoCertificar.idCertificar,null);
        // this.getLeadersSelectedEmpre(this.productoCertificar.asociadoId,this.productoCertificar.idCertificar);
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  getLideresCerAsociado(asociadoId,idProducto,search){
    this.leaderService.getLideresCerAsociados(asociadoId,idProducto,search).subscribe((data:any) => {
  console.log('***********',data);
  this.lideresCerAso=data.leaders;
  if (this.lideresCerAso.length>0) {

  this.dataSource = new MatTableDataSource(this.lideresCerAso);
  this.dataSource.data.forEach(row => {
    if (row.emailSend) {
      console.log('lo encontro');
      this.selection.select(row);
    }
      });
  this.cargando=false;
  }else{
    console.log('Aún no  se han filtrado los lideres');
    this.saveLideresCerAsociadoBack();
  }

    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  saveLideresCerAsociadoBack(){
    this.leaderService.saveLideresBackFiltrado(this.productoCertificar.asociadoId,this.productoCertificar.idCertificar).subscribe((data:any) => {
  console.log('+++++++++++++++++++',data);

  this.getLideresCerAsociado(this.productoCertificar.asociadoId,this.productoCertificar.idCertificar,null);
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  getLideresCerAsociadoBusque(){
    this.filtrandoLide=true;

  let search:any;
  if (this.busquedaLiaders.length>0) {

    search=this.busquedaLiaders;
    console.log('**es mayor',search);
  }else{
    search=null;
    console.log('++++Esta vacio',search);
  }
  this.leaderService.getLideresCerAsociados(this.productoCertificar.asociadoId,this.productoCertificar.idCertificar,search).subscribe((data:any) => {
  console.log('***********',data);
  this.lideresCerAso=data.leaders;
  this.dataSource = new MatTableDataSource(this.lideresCerAso);
  this.filtrandoLide=false;
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  verInfor(tipoModal:number,element?:any){
    console.log('abrir modal con información',element);
    const dialogRef = this.dialog.open(ModalInfoComponent, {
      width: '70%',
      data: {
      tipo: tipoModal,
      datos:element,
      }
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }
}
